const adminActionsNamespace = "[admin]: ";

const adminActionTypes = {
  SET_ADMIN_USER_FILTERS: `${adminActionsNamespace}SET_ADMIN_USER_FILTERS`,
  SET_ADMIN_USER_DATA: `${adminActionsNamespace}SET_ADMIN_USER_DATA`
};

export default adminActionTypes;
